import './StatusRingIcon.scss'

export default function StatusRingIcon({ color, size = 1.1 }) {
	return <div className="status-ring" style={{ borderColor: color, '--size': `${size}rem` }}></div>
}
